/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Edit_Mode_StatusInputs */



/**
* | output |
* | --- |
* | "Edit Mode Status" |
*
* @param {Editor_Edit_Mode_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_edit_mode_status = /** @type {((inputs?: Editor_Edit_Mode_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Edit_Mode_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Statut du mode edition")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeitungsmodus-Status")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato della modalità di modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Статус режима редактирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado del modo de edición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑模式状态")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集モードのステータス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादन मोड स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Status do Modo de Edição")
	return /** @type {LocalizedString} */ ("Edit Mode Status")
});